module.exports = __webpack_public_path__ + "static/media/logo-white-left-menubar.ce240da5.png";